module.exports = __webpack_public_path__ + "media/domenj/home_beta-2c911cf6.png";